import { CategoriesPage } from './CategoriesPage'
import { BurgerBoxPage } from './burger-box/BurgerBoxPage'
import { CouponsPage } from './coupons/CouponsPage'
import { GiftsPage } from './GiftsPage'
import { LunchMenuPage } from './lunch-menu/LunchMenuPage'
import { ProductsPage } from './products/ProductsPage'
import { PizzaConfigPage } from './pizza-config/PizzaConfigPage'
import { RecipesPage } from './recipes/RecipesPage'
import { UpsellPage } from './upsell/UpsellPage'

/**
 * `manager-menu` — the kitchen's catalogue.
 *
 * All eight pages ported: categories, gifts, recipes, burger-box,
 * pizza-config, coupons, products, lunch-menu - and one legacy never had:
 * `/upsell`, every upsell on one screen (FRONTEND.md §9.711).
 */
export const managerMenuModule = {
  name: 'manager-menu',
  routes: [
    {
      path: '/categories',
      page: 'categories',
      guard: { permission: 'categories' },
      component: CategoriesPage,
    },
    {
      path: '/gifts',
      page: 'gifts',
      guard: { permission: 'gifts' },
      component: GiftsPage,
    },
    {
      path: '/recipes',
      page: 'recipes',
      guard: { permission: 'recipes', franchiseModule: 'stock.recipes' },
      component: RecipesPage,
    },
    {
      // The route and the page file disagree in legacy; the route wins.
      path: '/kombo-box',
      page: 'burger-box',
      guard: { permission: 'burger_box' },
      component: BurgerBoxPage,
    },
    {
      path: '/pizza',
      page: 'pizza-config',
      guard: { permission: 'pizza' },
      component: PizzaConfigPage,
    },
    {
      path: '/coupons',
      page: 'coupons',
      guard: { permission: 'coupons' },
      component: CouponsPage,
    },
    {
      path: '/products',
      page: 'products',
      guard: { permission: 'products' },
      component: ProductsPage,
    },
    {
      path: '/lunch-menu',
      page: 'lunch-menu',
      component: LunchMenuPage,
    },
    {
      // §9.711, owner O91 - AGOS-only; legacy edits add-ons inside the product dialog and nowhere else.
      //
      // **On its own right, `upsell` - §9.744, BACKEND.md §10A.397, owner O114** (*"Práva na upseli
      // chýbajú"*). It rode on `products`, so nobody could be given the products without the upsells or the
      // other way round; the nine `/upsell` endpoints ask `upsell` now, and `V87` hands it to whoever held
      // `products`. The product dialog's own add-on list stays on `products`: it is part of editing a product.
      path: '/upsell',
      page: 'upsell',
      guard: { permission: 'upsell' },
      component: UpsellPage,
    },
  ],
} as const

export {
  BurgerBoxPage,
  CategoriesPage,
  CouponsPage,
  GiftsPage,
  LunchMenuPage,
  PizzaConfigPage,
  ProductsPage,
  RecipesPage,
  UpsellPage,
}
